/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_Contact_InformationInputs */

const en_users_detail_contact_information = /** @type {(inputs: Users_Detail_Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Information`)
};

const pt_br2_users_detail_contact_information = /** @type {(inputs: Users_Detail_Contact_InformationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações de Contato`)
};

/**
* | output |
* | --- |
* | "Contact Information" |
*
* @param {Users_Detail_Contact_InformationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_contact_information = /** @type {((inputs?: Users_Detail_Contact_InformationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_Contact_InformationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_contact_information(inputs)
	return pt_br2_users_detail_contact_information(inputs)
});